/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agents_TitleInputs */

const en_mk_sol_agents_title = /** @type {(inputs: Mk_Sol_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agents that make sense for a business like this`)
};

const id_mk_sol_agents_title = /** @type {(inputs: Mk_Sol_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen yang masuk akal untuk usaha seperti ini`)
};

/**
* | output |
* | --- |
* | "The agents that make sense for a business like this" |
*
* @param {Mk_Sol_Agents_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agents_title = /** @type {((inputs?: Mk_Sol_Agents_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agents_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agents_title(inputs)
	return en_mk_sol_agents_title(inputs)
});